import axios from "axios";
import getGlobalConfig from "../globalConfig";

const client = axios.create({
    baseURL: getGlobalConfig().baseUrl,
    timeout: 12_000,
    paramsSerializer: {
        indexes: null,
    }
});

export function getClient()
{
    return client;
}

// Adds access tokens in all api requests
// this interceptor is only added when the auth0 instance is ready and exports the getAccessTokenSilently method
export const addAccessTokenInterceptor = (getAccessTokenSilently) => {
    client.interceptors.request.use(async (config) => {
        try {
            const token = await getAccessTokenSilently();
            config.headers.Authorization = `Bearer ${token}`;

            if(getGlobalConfig().printToken)
            {
                console.log(token)
            }
        }
        catch(ex) {
            console.warn("An error occurred while appending Bearer token to the request: " + ex);
        }
      return config;
    });
};

export default client;
